import React, { FC, useCallback } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import { IAdditionalPoints } from '../types'

const AdditionalPoints: FC<IAdditionalPoints> = (props) => {
  const { list } = props

  const firstLowerCase = useCallback((str: string): string => {
    // делим слово на отдельные буквы
    const splitted = str.split('')

    // делаем первую букву в массиве заглавной
    const first = splitted[0].toLowerCase()

    // копируем массив что бы
    // не модицицировать splitted напрямую
    // если вдрг он нам понадобиться далее
    const rest = [...splitted]

    // удаляем первую букву из массива
    rest.splice(0, 1)

    // соединияем все обратно в строку
    return [first, ...rest].join('')
  }, [])

  if (list.length === 0) return null

  return (
    <div>
      <Heading h3='Дополнительные баллы к сумме ЕГЭ' spacing='small' />

      <List spacing='xxsmall' view='dots'>
        {list.map(({ name, id, scoreFrom, scoreTo }) => {
          const newName = firstLowerCase(name)

          if (scoreFrom && scoreTo && scoreTo !== scoreFrom) {
            return (
              <ListItem key={id}>
                <Text>
                  {`${scoreFrom}-${scoreTo} ${p11n(
                    scoreTo,
                    'балл',
                    'балла',
                    'баллов'
                  )} за ${newName}`}
                </Text>
              </ListItem>
            )
          }

          if (scoreFrom) {
            return (
              <ListItem key={id}>
                <Text>
                  {`${scoreFrom} ${p11n(
                    scoreFrom,
                    'балл',
                    'балла',
                    'баллов'
                  )} за ${newName}`}
                </Text>
              </ListItem>
            )
          }

          if (scoreTo) {
            return (
              <ListItem key={id}>
                <Text>
                  {`${scoreTo} ${p11n(scoreTo, 'балл', 'балла', 'баллов')} за ${newName}`}
                </Text>
              </ListItem>
            )
          }

          return (
            <ListItem key={id}>
              <Text firstLetterUppercase>{name}</Text>
            </ListItem>
          )
        })}
      </List>
    </div>
  )
}

export default AdditionalPoints
